import _ from 'lodash';

import {CCUtils, DataActionTypes, ActionTypes} from "./../../cc-imports";

const initialState = {
    lbs : {
        byId : [],
        bySponsor : []
    },
    lbStatuses: {
        lbStatuses: {},
        byLbId: {}
    },
    fetching: false,
    fetched: false,
    success: false,
    completed : false,
    type : DataActionTypes.GET
};

const processData = (oldLbStatus, lbs)=>{
    if(lbs){
        lbs=_.uniqBy(lbs, (lb)=>{return lb.user.id})
    }

    const byId = _.keyBy(lbs, 'id');
    var existingLbIds = oldLbStatus.lbStatuses;
    existingLbIds = _.merge({},existingLbIds,byId);

    var byLbId = CCUtils.groupByGetIds(lbs,'lbId');
    byLbId = _.mergeWith({}, byLbId, oldLbStatus.byLbId, CCUtils.customArrMerger);

    return {
        lbStatuses : existingLbIds,
        byLbId : byLbId
    }

};


const processLbs = (oldLbs, lbs)=>{

    const byId = _.keyBy(lbs, 'id');
    var existingLbIds = oldLbs.byId;
    existingLbIds = _.merge({}, existingLbIds,byId);

    var bySponsor = CCUtils.groupByGetIds(lbs,'sponsor', 'key');
    bySponsor = _.mergeWith({}, bySponsor, oldLbs.bySponsor, CCUtils.customArrMerger);

    return {
        byId : byId,
        bySponsor:bySponsor
    }

};


const LeaderBoardReducers = (state = initialState, action = {}) => {
    switch (action.type) {
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_LBS)):
            const newLbs = action.payload.data.item;
            return {...state, fetching: false, fetched: true, lbs: processLbs(state.lbs,newLbs), success: true, completed:false, type: action.meta.type, random:Math.random()}
            break;
        case (ActionTypes.getFulfilled(ActionTypes.GET_LBS)):
            return {
                ...state,
                fetching: false,
                fetched: true,
                success: false,
                completed : true,
                type: action.meta.type,
                random:Math.random()
            }
            break;
        case (ActionTypes.getPending(ActionTypes.GET_LBS)):
            return {...state, fetching: true,fetched: false, type: action.meta.type}
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_LBS)):
            return {...state, fetching: false, fetched: true, type: action.meta.type}
            break;


        case (ActionTypes.getCCFulfilled(ActionTypes.GET_LB_STATUS)):
            return {...state, fetching: false, fetched: true, lbStatuses: processData(state.lbStatuses,action.payload.data.item), success: true, completed:false, type: action.meta.type, random:Math.random()}
            break;
        case (ActionTypes.getFulfilled(ActionTypes.GET_LB_STATUS)):
            return {
                ...state,
                fetching: false,
                lbStatuses: processData(state.lbStatuses,action.payload.data.item),
                fetched: true,
                success: false,
                completed : true,
                type: action.meta.type,
                random:Math.random()
            }
            break;
        case (ActionTypes.getPending(ActionTypes.GET_LB_STATUS)):
            return {...state, fetching: true,fetched: false, type: action.meta.type}
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_LB_STATUS)):
            return {...state, fetching: false, fetched: true, type: action.meta.type}
            break;

        case (ActionTypes.SIGN_OUT_USER):
            return initialState;
            break;


        default :
            return state;
    }
};

export default LeaderBoardReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/LeaderBoardReducers.js